import Api from '@/services/Api'
import store from '@/store'
import base64 from '@/store/api/services/base64'

export default {
  createP12(data) {
    return Api.httpServer()
      .post('/cert/default.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  deleteP12(data) {
    return Api.httpServer()
      .post('/cert/default.asp?action=deleteP12', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  signin(data) {
    let sendData = { ...data }
    sendData.password = base64.encode(sendData.password)
    return Api.httpServer()
      .post('api/authen.asp', sendData)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  signout(data) {
    return Api.httpServer()
      .post('api/unauthen.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  authen(data) {
    return Api.httpServer()
      .post('api/authen.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  isAuthen(data) {
    return Api.httpServer()
      .post('api/isAuthen.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  prListCount(data) {
    return Api.httpServer()
      .post('pr/default.asp?controller=prdochd&action=listcount', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  SendMail(data) {
    return Api.httpServer().post('model_tb/default.asp?controller=Emp&action=SendMail', data)
  },

  linestatus(data) {
    return Api.httpServer()
      .post('line/linestatus.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  linenotify(data) {
    if (process.env.NODE_ENV === 'development') {
      // data.subject = data.subject
      let temp = { ...data }
      temp.message = '(to:' + temp.emp + ' -- Mode_development จะส่งหาตัวเองเท่านั้น) \n\n' + temp.message
      temp.emp = Api.curretnEmp().empCode
      data = temp
    }
    return Api.httpServer()
      .post('line/lineNotify.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramnotify(data) {
    // if (process.env.NODE_ENV === 'development') {
    //   // data.subject = data.subject
    //   let temp = { ...data }
    //   temp.message = '(to:' + temp.emp + ' -- Mode_development จะส่งหาตัวเองเท่านั้น) \n\n' + temp.message
    //   temp.emp = Api.curretnEmp().empCode
    //   data = temp
    // }
    return Api.httpServer()
      .post('line/telegram_callback_select.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramStatus(data) {
    return Api.httpServer()
      .post('line/telegram_callback_status.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramSelect(data) {
    return Api.httpServer()
      .post('line/telegram_callback_select.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramRegistor(data) {
    return Api.httpServer()
      .post('line/telegram_callback.asp?action=register', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramOTPdelete(data) {
    return Api.httpServer()
      .post('line/telegram_callback_otp.asp?action=OtpToDelete', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramOTP(data) {
    // pom create เรียกเดิมใช้ telegramOTPdelete ชื่อไม่สื่อความหมาย
    return Api.httpServer()
      .post('line/telegram_callback_otp.asp?action=sendOTP', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramotpcheck(data) {
    return Api.httpServer()
      .post('line/telegram_callback_otp.asp?action=checkOtp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },

  telegramUpdate(data) {
    return Api.httpServer()
      .post('line/telegram_callback_update.asp?action=upOTP', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  telegramDelete(data) {
    return Api.httpServer()
      .post('line/telegram_callback_delete.asp?action=delete', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailnotify(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}

    if (process.env.NODE_ENV === 'development') {
      // data.subject = data.subject
      let temp = { ...data }
      temp.message = '(to:' + temp.emp + ' -- Mode_development จะส่งหาตัวเองเท่านั้น) \n\n' + temp.message
      temp.emp = `${store.state.users.main.empCode}`
      data = temp
    }
    // data.subject = 'Develop:' + data.subject

    return Api.httpServer()
      .post('line/emailNotify.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },

  emailcustStatus(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTPcustomercheck.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailotpcustomer(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTPcustomer.asp?action=sendotp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailcustomer(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTPcustomer.asp?action=sendmail', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  insertTempReq(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTPcustomer.asp?action=inserttemp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  getUniqueID(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTPcustomer.asp?action=getUniqueID', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  deleteFolder(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/delete_folder.asp?action=deleteFolder', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  emailOTP(data) {
    // data = {emp:'0090',message:'ทดสอบ line Notify'}
    return Api.httpServer()
      .post('line/emailOTP.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  googleOTP(data) {
    return Api.httpServer()
      .post('line/googleOTP.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  googlestatus(data) {
    return Api.httpServer()
      .post('line/googlestatus.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  lineOTP(data) {
    return Api.httpServer()
      .post('line/lineOTP.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  lineotpcheck(data) {
    return Api.httpServer()
      .post('line/lineOTPCheck.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  OTPCheckDB(data) {
    return Api.httpServer()
      .post('line/lineOTPCheck.asp', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  budgetProject(data) {
    return Api.httpServer()
      .post('model_tb/default.asp?controller=Emp&action=Other&other=budgetProject', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  budget(data) {
    return Api.httpServer()
      .post('model_tb/default.asp?controller=Emp&action=Other&other=budget', data)
      .then((response) => Promise.resolve(response.data))
      .catch((error) => Promise.reject(error))
  },
  getEmpRole(data) {
    return Api.httpServer().post('itiso/default.asp?controller=emp&action=getEmpRole', data)
  },
  getEmp(data) {
    return Api.httpServer().post('model_tb/default.asp?controller=emp&action=getEmp', data)
  },
  prConfig(data) {
    return Api.httpServer().post('pr/default.asp?controller=prconfig&action=listbyparam', data)
  },
  empConfig(data) {
    return Api.httpServer().post('itiso/default.asp?controller=emp&action=empconfig', data)
  },
  empUpdate(data) {
    return Api.httpServer().post('itiso/default.asp?controller=emp&action=Update', data)
  }
}
